module.exports = __webpack_public_path__ + "static/integrations-mobile-2a071a86562a2284b700e9e24fee0c90.png";